import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { routerMiddleware } from "react-router-redux";
import createBrowserHistory from "history/createBrowserHistory";

import getRootReducer from "./reducers";


export const history = createBrowserHistory();

const routerHistory = routerMiddleware(history);
let store = null;

export default () => store = createStore(
    getRootReducer(),
    applyMiddleware(routerHistory, thunk)
);

export const getStore = () => store;


// WEBPACK FOOTER //
// ./src/store.js